"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCounterpartyFlagsSchema = exports.COUNTERPARTY_FLAG_RATIONALE_MAX = exports.COUNTERPARTY_FLAG_RATIONALE_MIN = void 0;
const zod_1 = require("zod");
// The three counterparty deal-breaker attributes the eligibility engine reads off
// Company: buyer_is_affiliate, supplier_is_affiliate, buyer_is_government_entity,
// buyer_insolvent and supplier_insolvent all resolve from these columns. No feed
// and no register populates them, so this surface is the only writer.
exports.COUNTERPARTY_FLAG_RATIONALE_MIN = 20;
exports.COUNTERPARTY_FLAG_RATIONALE_MAX = 2000;
const insolvencyDate = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/u, 'insolvency_declared_at must be ISO date YYYY-MM-DD');
exports.setCounterpartyFlagsSchema = zod_1.z
    .object({
    is_metycle_affiliate: zod_1.z.boolean().optional(),
    is_government_entity: zod_1.z.boolean().optional(),
    // A calendar day, because the facts compare the declaration against the evaluation date at UTC day granularity. Null clears the declaration, which is how a company is recorded solvent again.
    insolvency_declared_at: insolvencyDate.nullable().optional(),
    rationale: zod_1.z
        .string()
        .trim()
        .min(exports.COUNTERPARTY_FLAG_RATIONALE_MIN)
        .max(exports.COUNTERPARTY_FLAG_RATIONALE_MAX),
})
    .strict()
    // A rationale on its own is not an edit. Each flag takes a deal to not-eligible under an enabled Rivonia rule, so a no-op write must not reach the audit log.
    .refine((value) => value.is_metycle_affiliate !== undefined ||
    value.is_government_entity !== undefined ||
    value.insolvency_declared_at !== undefined, { message: 'at least one of the three flags must be present' });
//# sourceMappingURL=counterparty-flags.js.map